export enum ExplorerType {
  Directory = 'directory',
  File = 'file',
  Dataset = 'dataset',
}

export enum ExplorerNodeType {
  Directory = 'directory',
  File = 'file',
}
